import { FormAutocomplete, AutocompleteItem } from "components/Forms/FormAutocomplete";
import { useMemo } from "react";
import { Control } from "react-hook-form";

interface WasteStreamNameInputProps {
  control: Control<any>;
  wasteStreamNames: string[];
}

export const MergedWasteStreamNameInput = ({
  control,
  wasteStreamNames,
}: WasteStreamNameInputProps) => {
  const wasteStreamNameOptions: AutocompleteItem[] = useMemo(
    () =>
      wasteStreamNames.map((name) => ({
        value: name,
        label: name,
      })),
    [wasteStreamNames]
  );

  return (
    <FormAutocomplete
      name="wasteStreamName"
      label="Waste Stream Name"
      control={control}
      autocompleteItems={wasteStreamNameOptions}
      autocompleteProps={{
        freeSolo: true,
      }}
      rules={{
        required: "Waste stream name is required",
      }}
      hideErrors={true}
    />
  );
};
